import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import useCurrentUser from "data/advisor/useCurrentUser";

import { Onboarding } from "scenes/Onboarding";

function OnboardingRoutes() {
  const user = useCurrentUser();
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path}>
        <Onboarding advisor={user} />
      </Route>
    </Switch>
  );
}

OnboardingRoutes.propTypes = {};

OnboardingRoutes.defaultProps = {};

export default OnboardingRoutes;
